//#region frontend/entrypoints/sf-header.js
document.addEventListener("DOMContentLoaded", function() {
	const bodyElement = document.querySelector("body");
	const toggleButton = document.querySelector(".p-header__toggle");
	if (window.innerWidth > 1100) {
		bodyElement.classList.remove("is-menu-open");
		const wrapper = document.querySelector(".p-header__menu-toggle");
		const parentMenu = document.querySelector(".p-header__list--parent");
		const parentMenuItems = document.querySelectorAll(".p-header__item--parent");
		const childMenus = document.querySelectorAll(".p-header__list--child");
		const overlay = document.querySelector(".p-header__overlay");
		toggleButton.addEventListener("click", () => {
			if (toggleButton.classList.contains("is-active")) {
				toggleButton.classList.remove("is-active");
				wrapper.classList.remove("is-active");
				parentMenu.classList.remove("is-active");
				overlay.classList.remove("is-active");
			} else {
				toggleButton.classList.add("is-active");
				wrapper.classList.add("is-active");
				parentMenu.classList.add("is-active");
				overlay.classList.add("is-active");
			}
		});
		overlay.addEventListener("click", () => {
			toggleButton.classList.remove("is-active");
			wrapper.classList.remove("is-active");
			parentMenu.classList.remove("is-active");
			overlay.classList.remove("is-active");
		});
		parentMenuItems.forEach((item, index) => {
			item.addEventListener("click", () => {
				if (toggleButton.classList.contains("is-active")) if (item.classList.contains("is-active")) {
					toggleButton.classList.remove("is-active");
					wrapper.classList.remove("is-active");
					parentMenu.classList.remove("is-active");
					overlay.classList.remove("is-active");
				} else {
					parentMenuItems.forEach((menu) => menu.classList.remove("is-active"));
					item.classList.add("is-active");
					childMenus.forEach((menu) => menu.classList.remove("is-active"));
					const childMenu = document.getElementById(`childmenu-${index + 1}`);
					if (childMenu) childMenu.classList.add("is-active");
				}
				else {
					toggleButton.classList.add("is-active");
					wrapper.classList.add("is-active");
					parentMenu.classList.add("is-active");
					overlay.classList.add("is-active");
					parentMenuItems.forEach((menu) => menu.classList.remove("is-active"));
					item.classList.add("is-active");
					childMenus.forEach((menu) => menu.classList.remove("is-active"));
					const childMenu = document.getElementById(`childmenu-${index + 1}`);
					if (childMenu) childMenu.classList.add("is-active");
				}
			});
		});
	} else {
		const spWrapper = document.querySelector(".p-header__menu-wrap--sp");
		const spMenu = document.querySelectorAll(".p-header__item-text--sp");
		toggleButton.addEventListener("click", () => {
			if (toggleButton.classList.contains("is-active")) {
				bodyElement.classList.remove("is-menu-open");
				toggleButton.classList.remove("is-active");
				spWrapper.classList.remove("is-active");
			} else {
				bodyElement.classList.add("is-menu-open");
				toggleButton.classList.add("is-active");
				spWrapper.classList.add("is-active");
			}
		});
		spMenu.forEach((item, index) => {
			item.addEventListener("click", () => {
				if (item.classList.contains("is-open")) {
					item.classList.remove("is-open");
					item.nextElementSibling.classList.remove("is-open");
				} else {
					item.classList.add("is-open");
					item.nextElementSibling.classList.add("is-open");
				}
			});
		});
	}
});
//#endregion
